<div class="outer-content">
    <div class="float-left bg-white card-background wh-auto">
        <div class="fieldHeight">
            <div class="row">
                <app-content-top-nav [visibleSaveProgress]='false' [visibleBackNav]='true' [enableBackNav]='true'>
                </app-content-top-nav>
            </div>
            <div class="row">
                <div class="col-md-12 clear-all title-inner-container">
                    <h1 class="custom-header-h2 responsive-text-8" id="beforeYouStart-header">
                        {{contentData.header}}</h1>
                </div>
            </div>
            <div class="content-container">
                <div class="row">
                    <p class="content-top mt-0" [innerHTML]="contentData.introduction"></p>
                </div>

                <div class="row">
                    <h3 class="custom-header-h2 mt-5 " id="string_PensionWiseTitle">
                        {{contentData.subHeader}}
                    </h3>
                </div>

                <div class="row">
                    <p class="inner-content-data-text" [innerHTML]="contentData.loginRegistrationSteps"></p>
                </div>
            </div>

            <div class="row">
                <app-content-bottom-nav (onNextHandler)="onLogin()"
                    [userInputDetail]="userInputDetail['loginbuttonConfig']" [buttonType]="'normalCTA'">
                </app-content-bottom-nav>
            </div>


        </div>
    </div>
</div>